"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = withRouter;

var _mapContextToProps = _interopRequireDefault(require("@restart/context/mapContextToProps"));

var _RouterContext = _interopRequireDefault(require("./RouterContext"));

function withRouter(Component) {
  return (0, _mapContextToProps["default"])({
    consumers: _RouterContext["default"],
    mapToProps: function mapToProps(context) {
      return context;
    },
    displayName: "withRouter(" + (Component.displayName || Component.name) + ")"
  }, Component);
}

module.exports = exports.default;